import { render, staticRenderFns } from "./CateTable.vue?vue&type=template&id=fcbf10d6&scoped=true"
import script from "./CateTable.vue?vue&type=script&lang=js"
export * from "./CateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf10d6",
  null
  
)

export default component.exports